"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getStepperPropsWithClearedDisabledProp;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

function getStepperPropsWithClearedDisabledProp(stepperInputProps) {
  if (stepperInputProps) {
    var __disabled = stepperInputProps.disabled,
        rest = (0, _objectWithoutProperties2.default)(stepperInputProps, ["disabled"]);
    return rest;
  }

  return {};
}

module.exports = exports.default;